import { render, staticRenderFns } from "./HistorySnackbars.vue?vue&type=template&id=5105b676&scoped=true&lang=pug&"
import script from "./HistorySnackbars.vue?vue&type=script&lang=js&"
export * from "./HistorySnackbars.vue?vue&type=script&lang=js&"
import style0 from "./HistorySnackbars.vue?vue&type=style&index=0&id=5105b676&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5105b676",
  null
  
)

export default component.exports